import _styled, { default as _styled2, default as _styled3, default as _styled4 } from "styled-components";
const _excluded = ["style", "children", "options"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import Divider from '@adsk/alloy-react-divider';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
import Option from './layout/FooterOption';
const Footer = _ref => {
  let {
      style,
      children,
      options = []
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const hasMultipleChildren = React.Children.toArray(children).length > 1;
  return /*#__PURE__*/React.createElement(_StyledDiv, _extends({}, props, {
    $_css: [style]
  }), /*#__PURE__*/React.createElement(Divider, null), options.length > 0 && /*#__PURE__*/React.createElement(_StyledDiv2, {
    $_css2: [{
      padding: '0px 8px',
      background: theme.tokens.colors.background.secondary.value
    }]
  }, options.map((option, i) => /*#__PURE__*/React.createElement(_StyledDiv3, {
    key: i
  }, /*#__PURE__*/React.createElement(Option, option)))), /*#__PURE__*/React.createElement(_StyledDiv4, {
    $_css3: hasMultipleChildren ? 'space-between' : 'right'
  }, children));
};
Footer.displayName = 'Footer';
Footer.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Content that will be displayed in the main (lower) area of the Footer */
  children: PropTypes.any,
  /** Optional props to set on the Clear button */
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.node.isRequired,
    defaultChecked: PropTypes.bool,
    onChange: PropTypes.func.isRequired
  }))
};
export default Footer;
var _StyledDiv = _styled("div")`${p => p.$_css}`;
var _StyledDiv2 = _styled2("div")`${p => p.$_css2}`;
var _StyledDiv3 = _styled3("div")({
  display: 'flex',
  alignItems: 'center',
  padding: '16px 8px'
});
var _StyledDiv4 = _styled4("div").withConfig({
  displayName: "Footer___StyledDiv4",
  componentId: "sc-f2unt0-0"
})(p => ({
  display: 'flex',
  justifyContent: p.$_css3,
  alignItems: 'center',
  padding: '0px 16px',
  height: 48
}));
//# sourceMappingURL=Footer.js.map